/** Identity of the running bundle: frontend build vs. the API contract it was generated for. */
export const APP_BUILD: string = __APP_BUILD__
/** `info.version` of contracts/openapi.yaml at build time. */
export const CLIENT_CONTRACT_VERSION: string = __CONTRACT_VERSION__

/** Parses `major.minor.patch`; null when not a plain semver. */
export function parseVersion(v: string): [number, number, number] | null {
  const m = /^(\d+)\.(\d+)\.(\d+)/.exec(v)
  return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null
}

/** True when `server` has a newer major.minor than `client` (patch differences never force an update). */
export function isContractNewer(server: string, client: string = CLIENT_CONTRACT_VERSION): boolean {
  const s = parseVersion(server)
  const c = parseVersion(client)
  if (!s || !c) return false
  return s[0] !== c[0] ? s[0] > c[0] : s[1] > c[1]
}
